import React from 'react';

const deleteButton = props => (
  <button
    aria-label="Delete"
    className="delete p-0 border-0"
    onKeyDown={props.handleKeyDown}
    onClick={props.handleDelete}
  >
    <span className="fa-stack fa-xs d-flex align-items-center justify-content-center">
      <i className="fas fa-circle fa-stack-2x" />
      <i className="fas fa-times fa-stack-1x fa-inverse" />
    </span>
  </button>
);

export default deleteButton;
